// src/data/allproduct.js

// 🔥 Import images (same as your pages)
import img6501 from "../images/Engine-car/synthetic/6501/pictures_FF6501-1_green_front_1200.jpg";
import img6702 from "../images/Engine-car/synthetic/6702/pictures_FF6702-1_green_front_1200.jpg";
import img6711 from "../images/Engine-car/synthetic/6711/pictures_FF6711-1_green_front_1200.jpg";
import img6724 from "../images/Engine-car/synthetic/6724/pictures_FF6724_1_green_front_1200.jpg";
import img6726 from "../images/Engine-car/synthetic/6726/pictures_FF6726-1_green_front_1200.jpg";

import img6201 from "../images/motorcycle/motor-oil/6201/pictures_FF6201-1_green_front_1200.jpg";
import img6208 from "../images/motorcycle/motor-oil/6208/pictures_FF6208_1_green_front_1200_2.jpg";
import img3002 from "../images/service-fluid/3002/FF3002_025_front.png"
import img4211 from "../images/service-fluid/4211/4211_5front.webp"
import img4212 from "../images/service-fluid/4212/4212_1front.webp"
import img4213 from "../images/service-fluid/4213/4213_1front.webp"
import img6707 from "../images/Engine-car/synthetic/6707/6707_1.png"
import img8605 from "../images/gear/gera-oil/8605/8605_1front.webp"
import img8614 from "../images/gear/gera-oil/8614/8614_1front.webp"
import img8615 from "../images/gear/gera-oil/8615/8615_1front.webp"
 import img8616 from "../images/gear/gera-oil/8616/8616_1front.webp"
 import img8701 from "../images/gear/gera-oil/8701/8701_1front.webp"
 import img8702 from "../images/gear/gera-oil/8702/8702_1front.webp"
 import img8710 from "../images/gear/gera-oil/8710/8710_1front.webp"

// 🔥 ALL PRODUCTS (MANUAL - BEST FIX)
const allProducts = [
  // CAR PRODUCTS
  {
    id: "6501",
    type: "synthetic",
    name: "FANFARO TSE 5W-30 6501",
    image: img6501,
  },
  {
    id: "6702",
    type: "synthetic",
    name: "FANFARO VSX 5W-40 6702",
    image: img6702,
  },
  {
    id: "6711",
    type: "synthetic",
    name: "FANFARO ESX 0W-40 6711",
    image: img6711,
  },
  {
    id: "6724",
    type: "synthetic",
    name: "FANFARO NSX 0W-20 6724",
    image: img6724,
  },
  {
    id: "6726",
    type: "synthetic",
    name: "FANFARO XTR 0W-30 6726",
    image: img6726,
  },

  // MOTOR PRODUCTS
  {
    id: "6201",
    type: "motor",
    name: "FANFARO M-4T Plus 6201",
    image: img6201,
  },
  {
    id: "6208",
    type: "motor",
    name: "FANFARO S-4T+ 20W-50 6208",
    image: img6208,
  },
  // Service Fluids
  {
     id: "3002",
    type: "service",
    name: "FANFARO Dot-4 Brake Fluid 3002",
    image: img3002,

  },
  {
     id: "4211",
    type: "service",
    name: "FF Coolant G11 4211",
    image: img4211,

  },
   {
     id: "4212",
    type: "service",
    name: "FANFARO Coolant G12+ 4212",
    image: img4212,

  },
    {
     id: "4213",
    type: "service",
    name: "FANFARO Coolant G13 4213",
    image: img4213,

  },
  {
    id:"6707",
    type: "synthetic",
    name: "FANFARO VDX 5W-30 6707",
    image: img6707,

  },
  // Gear
   {
    id:"8605",
    type: "gear",
    name: "FANFARO ATF SP-IV 8605",
    image: img8605,

  },
    {
    id:"8614",
    type: "gear",
    name: "FANFARO AZF 8 8614",
    image: img8614,

  },
   {
    id:"8615",
    type: "gear",
    name: "FANFARO ATF VI 8615",
    image: img8615,

  },
  {
    id:"8616",
    type: "gear",
    name: "FANFARO DCT 8616",
    image: img8616,

  },
    {
    id:"8701",
    type: "gear",
    name: "FANFARO MAX 4 80W-90 GL-4 8701",
    image: img8701,

  },
   {
    id:"8702",
    type: "gear",
    name: "FANFARO MAX 4+ 75W-90 GL-4+ 8702",
    image: img8702,

  },
     {
    id:"8710",
    type: "gear",
    name: "FANFARO MAX 7 75W-80 8710",
    image: img8710,

  },


];

export default allProducts; 
